module.exports = __webpack_public_path__ + "img/notary-journal_B09KN4H1HL.86ce554f.jpg";